export const auth = {
  login: "Login",
  loginSubtitle: "Sign in to your account",
  register: "Register",
  registerSubtitle: "Create a new account",
  usernamePlaceholder: "username",
  emailPlaceholder: "your.email@example.com",
  email: "Email Address",
  password: "Password",
  confirmPassword: "Confirm Password",
  forgotPassword: "Forgot password",
  noAccount: "Don't have an account",
  hasAccount: "Already have an account",
  loginButton: "Login",
  registerButton: "Register",
  loginSuccess: "Successfully logged in.",
  welcomeBack: "Welcome back, {{name}}",
  passwordRequirementsTitle: "Password requirements:",
  passwordRequirementLength: "At least 8 characters",
  passwordRequirementUppercase: "At least one uppercase letter",
  passwordRequirementLowercase: "At least one lowercase letter",
  passwordRequirementNumber: "At least one number",
  passwordRequirementSpecial: "At least one special character",
  passwordsDoNotMatch: "Passwords do not match",
  passwordsMatch: "Passwords match",
  registrationLoading: "Registering...",
  verifyEmailTitle: "Verify your email",
  verifyEmailSubtitle: "Thanks for registering!",
  verifyEmailSent:
    "We've sent an email to {{email}}. Please click the link to activate your account.",
  verifyEmailNextStep: "After verification, you can sign in.",
  registrationCompleteTitle: "Registration complete",
  registrationCompleteSubtitle: "Thanks for registering!",
  registrationCompleteBody:
    "Email verification is not required in this environment.",
  registrationCompleteNextStep: "You can sign in with your new account.",
  verificationEmailSent: "Verification email sent.",
  verifyBeforeLogin: "Please verify your email before logging in.",
  verificationNotRequired:
    "Email verification is not required in this environment.",
  verificationNotRequiredHint:
    "You can enable it in the Admin Dashboard after adding a mail connection in the application-local.properties.",
  invalidCredentials: "Email or password is incorrect.",
  accountNotVerified: "Your account has not been verified yet.",
  accountLocked: "Your account has been disabled. Please contact support.",
  accountLockedTemporary:
    "Your login is temporarily locked. Please try again later or reset your password.",
  accountLockedTemporaryTitle: "Login temporarily locked",
  accountLockedTemporaryMessage:
    "Too many failed attempts. Try again in {{time}}.",
  accountLockedTemporaryHint:
    "Resetting your password clears the lock immediately.",
  verifyEmailTokenMissing: "Token is missing.",
  verifyEmailSuccess: "Email verified successfully. You can now sign in.",
  verifyEmailInvalidToken: "Invalid or unknown token.",
  verifyEmailAlreadyUsed: "Email has already been verified.",
  verifyEmailExpired: "The verification link has expired.",
  verifyAccountTitle: "Email verification required",
  verifyAccountSubtitle:
    "You have successfully registered and signed in, but your account is not active yet.",
  verifyAccountBody:
    "We sent a verification email to {{email}}.",
  verifyAccountNextStep:
    "Please click the link in that email to activate your account.",
  verifyAccountSpamHint:
    "If it did not arrive, please check your spam or junk folder too.",
  verifyAccountResendHint:
    "If you did not receive it, you can request the link again.",
  verifyAccountResendButton: "Resend verification link",
  verifyAccountResendButtonCooldown: "Resend in {{time}}",
  verifyAccountResendCooldownHint:
    "You can request a new link in {{time}}.",
  verifyAccountResendLoading: "Sending verification link...",
  verifyAccountResendSuccess: "A new verification link has been sent.",
  verifyAccountResendWaiting:
    "Please wait {{time}} before sending the link again.",
  resetTitle: "Set a new password",
  resetSubtitle: "Please enter your new password.",
  resetInvalidLink: "Invalid or expired link.",
  resetErrorTitle: "Could not change your password.",
  resetErrorHint: "The link is invalid or has expired.",
  resetSuccess: "Password changed successfully.",
  resetSuccessBody: "Your password has been updated.",
  resetBackToLogin: "Back to login",
  resetPasswordLabel: "New password",
  resetConfirmLabel: "Confirm password",
  resetSave: "Save password",
  resetSaving: "Saving...",
  resetPasswordInvalid: "The password does not meet the requirements.",
  resetRequestTitle: "Reset password",
  resetRequestSubtitle: "Enter your email address to receive a reset link.",
  resetRequestSend: "Send link",
  resetRequestSent:
    "If an account with this email exists, an email has been sent.",
  resetMissingData: "Required data is missing.",
  resetLinkUsed: "This link has already been used.",
  resetLinkExpired: "The link has expired.",
  refreshTokenInvalid: "Refresh token is invalid.",
  refreshTokenUserNotFound: "User not found.",
  refreshTokenNotFound: "Token not found.",
  refreshTokenExpired: "Token is expired or revoked.",
  maintenanceAdminOnly:
    "Maintenance is active. Only administrators can sign in right now.",
};

export const account = {
  title: "My Account",
  subtitle: "Manage your account information and settings",
  profile: "Profile",
  settings: "Settings",
  messages: "Messages",
  activity: "Activity",
  email: "Email Address",
  username: "Username",
  password: "Password",
  role: "Role",
  memberSince: "Member since",
  websitesAdded: "Websites Added",
  categorizations: "Categorizations",
  edits: "Edits",
  recentActivity: "Recent Activity",
  administrator: "Administrator",
  registeredUser: "Registered User",
  statistics: "Statistics",
  totalActivity: "Total activity",
  activitySummary: "Activity summary",
  activitySummaryDesc: "Overview of your recent actions",
  activitySearchLabel: "Search activity",
  activitySearchPlaceholder: "Search actions or titles",
  activityFilterLabel: "Filter by type",
  activityFilterAll: "All types",
  activityFilterTimeLabel: "Time period",
  activityFilterTime: "Time period",
  activityFilterTimeALL: "All time",
  activityFilterTimeWEEK: "Last week",
  activityFilterTimeMONTH: "Last month",
  activityFilterTimeYEAR: "Last year",
  activityResultsPerPage: "Results per page",
  activityEmpty: "No activity entries found.",
  activityCount: "{{count}} total entries",
  activityResultsSummary: "Showing {{start}}-{{end}} of {{count}} results",
  profilePictureUpload: "Profile Picture Upload",
  profilePictureDescription:
    "This function would normally open a file upload dialog.",
  emailChangeRequested: "Email change requested",
  emailChangeDescription:
    "Please confirm the change via the link in your email.",
  emailChangeVerifySubtitle: "Your email address has been updated.",
  emailChangeVerifyBody:
    "We've sent an email to {{email}}. Please click the link to confirm the change.",
  emailChangeCompleteTitle: "Email change complete",
  emailChangeCompleteSubtitle: "Your email address has been updated.",
  emailChangeCompleteNextStep: "You can sign in with your new email.",
  usernameChanged: "Username changed successfully",
  passwordChanged: "Password changed successfully",
  passwordChangeConfirmation: "You will receive a confirmation email.",
  verified: "Verified",
  notVerified: "Not verified",
  changeEmail: "Change Email Address",
  changeEmailDescription:
    "Change your email address. You will receive a confirmation link.",
  newEmail: "New Email Address",
  emailRequired: "Please enter an email address.",
  emailInvalid: "Please enter a valid email address.",
  emailTooLong: "Email addresses must be at most 255 characters.",
  changeUsername: "Change Username",
  changeUsernameDescription: "Change your username",
  newUsername: "New Username",
  usernameTaken: "This username is already taken.",
  usernameUnchanged: "Please enter a different username.",
  usernameRequired: "Please enter a username.",
  usernameTooLong: "Usernames must be at most 255 characters.",
  emailUnchanged: "Please enter a different email address.",
  emailTaken: "This email address is already in use.",
  currentPasswordIncorrect: "The current password is incorrect.",
  passwordUnchanged: "Please choose a different password.",
  changePassword: "Change Password",
  changePasswordDescription: "Change your password",
  currentPassword: "Current Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  change: "Change",
  recentActivityDescription: "Your recent actions in the system",
  messagesDescription: "Updates from administrators and system events.",
  messagesEmpty: "No messages yet.",
  messagesUnread: "Unread",
  messagesRead: "Read",
  messagesSender: "Sender",
  messagesSentAt: "Sent",
  messagesMarkRead: "Mark as read",
  messagesMarkAllRead: "Mark all as read",
  messagesResultsPerPage: "Messages per page",
  messagesResultsSummary: "Showing {{start}}-{{end}} of {{count}} messages",
  messagesFromSystem: "System",
  messagesTypeSYSTEM: "System",
  messagesTypeADMIN: "Admin",
  messagesTypeUSER: "User",
  messagesAdminLink: "Send messages from the Admin Dashboard",
  messagesAdminDescription:
    "Open the admin area to send messages to users.",
  messagesAdminCta: "Open Admin Messages",
  ticketAdminLink: "Manage tickets in the Admin Dashboard",
  ticketAdminDescription:
    "Open the admin area to process incoming bug and feature tickets.",
  ticketAdminCta: "Open Admin Tickets",
  tickets: "Tickets",
  ticketsDescription:
    "Report bugs, request features, and follow ticket replies with attachments.",
  ticketCreateTitle: "Create ticket",
  ticketInboxTitle: "My tickets",
  ticketTitleLabel: "Title",
  ticketTitlePlaceholder: "Short summary of your issue or idea",
  ticketType: "Type",
  ticketTypeBUG: "Bug",
  ticketTypeFEATURE: "Feature",
  ticketTypeFEEDBACK: "Feedback",
  ticketMessage: "Message",
  ticketMessagePlaceholder: "Describe your issue, request, or question...",
  ticketAttachments: "Attachments (up to 5 images)",
  ticketAttachmentsLimit: "You can attach up to 5 images per message.",
  ticketFilesSelected: "files selected",
  ticketCreateAction: "Create ticket",
  ticketCreated: "Ticket created.",
  ticketFilterAll: "All statuses",
  ticketListEmpty: "No tickets found.",
  ticketMessagesShort: "messages",
  ticketAttachmentsShort: "attachments",
  ticketReplyTitle: "Reply",
  ticketReplyPlaceholder: "Add a follow-up message...",
  ticketReplyAction: "Send reply",
  ticketCloseDefault: "Default close message",
  ticketCloseCustom: "Custom close message",
  ticketCloseMessagePlaceholder: "Add your custom close text...",
  ticketCloseAction: "Close ticket",
  ticketCloseConfirmTitle: "Close this ticket",
  ticketCloseConfirmDescription:
    "You can reopen it by sending a new message within the reopen window.",
  ticketCloseConfirmAction: "Close ticket",
  ticketClosed: "Ticket closed.",
  ticketOpenAttachment: "Open",
  ticketSystemReopenedAfterMessage: "Ticket reopened after new message.",
  ticketSystemReopenedByAdmin: "Ticket reopened by admin.",
  ticketSystemClosedByReporter: "Ticket closed by reporter.",
  ticketSystemClosedByAdministrator: "Ticket closed by admin.",
  ticketSystemAttachmentRemovedByAdmin:
    "Attachment removed by admin ({{admin}}): {{filename}}",
  ticketTitleRequired: "Please enter a title.",
  ticketMessageOrAttachmentRequired:
    "Add a message or at least one attachment.",
  ticketCustomCloseRequired: "Custom close message is required.",
  ticketReopenUntil: "Reopen available until",
  ticketStatusOPEN: "Open",
  ticketStatusIN_PROGRESS: "In progress",
  ticketStatusCLOSED: "Closed",
  dataPrivacyTitle: "Data & Privacy",
  dataPrivacyDescription:
    "Download your personal data and manage account deletion.",
  aiSearchToggleLabel: "AI Search",
  aiSearchStatusOn: "ON",
  aiSearchStatusOff: "OFF",
  aiSearchStatusForcedOff: "FORCED OFF (admin)",
  aiSearchStatusHintOn:
    "Natural-language parsing is active for category, region, and text filters.",
  aiSearchStatusHintOff:
    "Plain text search mode. Turn AI search on to resolve categories and regions automatically.",
  aiSearchStatusHintForcedOff:
    "AI search is disabled by system configuration. Your saved preference stays available.",
  aiSearchTurnOn: "Turn on AI search",
  aiSearchTurnOff: "Turn off AI search",
  dataExportButton: "Download my data",
  dataExportLoading: "Preparing export...",
  dataExportSuccess: "Your personal data export was downloaded.",
  dataExportFailed: "Failed to download your personal data export.",
  accountDeleteDescription:
    "Deleting your account removes your personal data. Website contributions are anonymized.",
  accountDeleteButton: "Delete account",
  accountDeleteConfirmTitle: "Delete account permanently",
  accountDeleteConfirmDescription:
    "This action cannot be undone. Enter your current password to continue.",
  accountDeleteConfirmButton: "Delete permanently",
  accountDeleteLoading: "Deleting account...",
  accountDeletePasswordRequired: "Please enter your current password.",
  accountDeleteSuccess: "Your account has been deleted.",
  accountDeleteFailed: "Failed to delete your account.",
  websiteAdded: "Website added",
  categorizationEdited: "Categorization edited",
  categorizationPerformed: "Categorization performed",
};

export const activity = {
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  RESTORE: "Restored",
  SUGGEST: "Suggested",
};

export const profilePicture = {
  title: "Profile picture",
  subtitle: "Choose a picture for your profile.",
  previewAlt: "Profile picture preview",
  previewLabel: "Displayed wherever your profile is visible.",
  previewNoticeTitle: "This is a preview",
  previewNoticeBody: "Changes are saved automatically.",
  select: "Select image",
  change: "Change picture",
  remove: "Remove picture",
  invalidFile:
    "This file doesn’t seem to be a valid image. Please choose another one.",
  maxOriginal: "This image is too large. Please choose a smaller file.",
  empty: "Please choose a non-empty image file.",
  invalidType: "This file type is not supported.",
  cropInstruction: "Changes are saved automatically.",
  mobileHint: "Profile picture editor is below. Tap to jump.",
  apply: "Apply",
  upload: "Save picture",
  uploading: "Saving picture...",
  hint: "The image will be optimized automatically.",
  uploadSuccess: "Your profile picture has been updated.",
  removeSuccess: "Profile picture removed.",
  tooLarge: "The processed image exceeds the allowed size.",
  uploadWarning:
    "This image could not be saved. Please try a different picture.",
  registrationNote:
    "Optional: your picture will be uploaded right after registration.",
  notFound: "Profile picture not found.",
  uploadFailed:
    "This image could not be saved. Please try a different picture.",
  uploadFailedDifferent:
    "This image could not be saved. Please try a different picture.",
  uploadNetworkError:
    "Something went wrong while saving your picture. Please try again.",
  authExpired:
    "You're no longer signed in. Please sign in again to save your picture.",
  controls: {
    move: "Move",
    moveHint: "Drag the image",
    zoom: "Zoom",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    zoomSliderHint: "Use the slider or + / -",
    rotate: "Rotate",
    rotateLeft: "Rotate 90° left",
    rotateRight: "Rotate 90° right",
    rotationValue: "Angle:",
    reset: "Reset",
  },
};
